import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_PROGRAM_CREATIVES = Symbol('affiliate-program.creatives');

export const AFFILIATE_PROGRAM_CREATIVES_ROUTE_NAME = Symbol('affiliate-program.creatives');
export const AFFILIATE_PROGRAM_CREATIVES_LIST_ROUTE_NAME = Symbol('affiliate-program.creatives.list');

export const AFFILIATE_PROGRAM_CREATIVES_LIST_API_URL = 'admin/creatives/list';
export const AFFILIATE_PROGRAM_CREATIVES_LIST_QUERY_KEY = 'affiliate-program.creatives.list';

export const AFFILIATE_PROGRAM_ACTIVATE_CREATIVE_API_URL = 'admin/creatives/active_creatives';
export const AFFILIATE_PROGRAM_ACTIVATE_CREATIVE_MUTATION_KEY = 'affiliate-program.creatives.activate';

export const AFFILIATE_PROGRAM_DEACTIVATE_CREATIVE_API_URL = 'admin/creatives/inactive_creatives';
export const AFFILIATE_PROGRAM_DEACTIVATE_CREATIVE_MUTATION_KEY = 'affiliate-program.creatives.deactivate';

export const AFFILIATE_PROGRAM_ARCHIVE_CREATIVE_API_URL = 'admin/creatives/archive';
export const AFFILIATE_PROGRAM_ARCHIVE_CREATIVE_MUTATION_KEY = 'affiliate-program.creatives.archive';

export const AFFILIATE_PROGRAM_UNARCHIVE_CREATIVE_API_URL = 'admin/creatives/unarchive';
export const AFFILIATE_PROGRAM_UNARCHIVE_CREATIVE_MUTATION_KEY = 'affiliate-program.creatives.unarchive';

export const AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.CREATIVES_SHOW),
  CREATE: new Permission(PermissionsList.admin.CREATIVES_CREATE),
  EDIT: new Permission(PermissionsList.admin.CREATIVES_EDIT),
  ARCHIVE: new Permission(PermissionsList.admin.CREATIVES_ARCHIVATION_CREATIVES),
  ACTIVATE: new Permission(PermissionsList.admin.CREATIVES_ACTIVE_OR_INACTIVE_CREATIVES),
};
